import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserPen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 15,
	viewBox: "0 0 19 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.625 7.75C8.53906 7.75 10.125 6.19141 10.125 4.25C10.125 2.33594 8.53906 0.75 6.625 0.75C4.68359 0.75 3.125 2.33594 3.125 4.25C3.125 6.19141 4.68359 7.75 6.625 7.75ZM7.99219 9.0625H5.23047C2.60547 9.0625 0.5 11.1953 0.5 13.8203C0.5 14.3398 0.910156 14.75 1.42969 14.75H9.27734C9.22266 14.6133 9.22266 14.4492 9.25 14.2852L9.66016 12.3438C9.71484 12.0703 9.82422 11.8242 10.0156 11.6328L11.2734 10.4023C10.4258 9.58203 9.27734 9.0625 7.99219 9.0625ZM10.6445 12.2617C10.5625 12.3438 10.5352 12.4258 10.5078 12.5078L10.125 14.4766C10.0703 14.6406 10.2344 14.8047 10.3984 14.75L12.3672 14.3672C12.4492 14.3398 12.5312 14.3125 12.6133 14.2305L15.3203 11.5234L16.0312 10.8125L14.0625 8.84375L10.6445 12.2617ZM17.6992 7.75L17.125 7.17578C16.7422 6.79297 16.1133 6.79297 15.7305 7.17578L14.6914 8.21484L16.6602 10.1836L17.6992 9.14453C18.082 8.76172 18.082 8.13281 17.6992 7.75Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgUserPen);
export { ForwardRef as ReactComponent };
